import { FetchError } from '../../data/fetchError'

export function isXiaError(err: any): boolean {
  if (!('type' in err)) return false
  if (!('title' in err)) return false
  if (!('status' in err)) return false
  if (!('detail' in err)) return false
  if (!('helplink' in err)) return false
  if (!('extensions' in err)) return false
  if (!('errors' in err)) return false

  return true
}

export function isValidationError(err: any): boolean {
  if (!('type' in err)) return false
  if (!('title' in err)) return false
  if (!('status' in err)) return false
  if (!('errors' in err)) return false
  if (!('traceId' in err)) return false

  const title: string = err.title.toString()
  if (!title.toLowerCase().includes('validation')) return false

  return true
}

function getValidationErrorMessage(errs: any): string {
  const errors = Object.keys(errs).map(e => {
    let currErr = errs[e]
    if (Array.isArray(currErr)) currErr = currErr[0]
    return currErr
  })

  return errors.join('\n')
}

export interface HandleableError {
  status: number
  message: string
  title?: string
}

export interface MalwareErrorMessage {
  scanStatus: string
  threatFound: boolean
  threatNames: string[]
  scanDate: string
}

export function getHandleableError(err: any): HandleableError {
  // If status is 423 it means it has malware - handle this first regardless of error type
  if (err?.status === 423) {
    try {
      // Try to extract malware message from the response
      let responseData = err.info || err
      if (typeof responseData === 'string') {
        responseData = JSON.parse(responseData)
      }

      // Extract malware scan status from detail
      const detailString = responseData.detail
      if (detailString) {
        const malwareData = JSON.parse(detailString)
        if (malwareData.scanStatus) {
          return {
            status: err.status as number,
            message: malwareData.scanStatus,
            title: err.title || err.message,
          }
        }
      }
    } catch {
      // Fallback if parsing fails
      return {
        status: err.status as number,
        message:
          err.message ||
          'File could not be scanned for malware. Please try again.',
        title: err.title,
      }
    }
  }

  if (isXiaError(err))
    return {
      status: err.status,
      message: err.errors[0].message,
      title: err.title,
    }

  if (isValidationError(err))
    return {
      status: err.status,
      title: err.title,
      message: getValidationErrorMessage(err.errors),
    }

  if (err instanceof FetchError)
    return {
      status: err.status as number,
      message: err.info,
      title: err.message,
    }

  const error = err as Error

  return {
    status: 999,
    message: error.message,
  }
}
